import { pick } from 'lodash';

export const EStaticComponentTypes = <const>{
  TEXT: 'text',
  IMAGE: 'image',
  VIDEO: 'video',
  EXTERNAL_VIDEO: 'external_video',
  PDF: 'pdf'
};

export const EComponentTypes = <const>{
  ...EStaticComponentTypes,
  ELEARNING_QUESTION: 'question',
  QUESTION_TEXT: 'question_text',
  QUESTION_MULTIPLE_CHOICE: 'question_multiple_choice',
  QUESTION_SLIDER: 'question_slider',
  QUESTION_DATE_TIME: 'question_datetime',
  QUESTION_NUMBER: 'question_number',
  QUESTION_DROPDOWN: 'question_dropdown',
  QUESTION_BOOLEAN: 'question_boolean',
  QUESTION_FILE_UPLOAD: 'question_file_upload',
  QUESTION_CHECKLIST: 'question_checklist',
  ORDER: 'question_order',
  PAIRING: 'question_pairing',
  IMAGE_HOTSPOT: 'question_image_hotspot',
  IMAGE_DROPDOWN: 'question_image_dropdown',
};

export const EComponentQuestionTypes = pick(EComponentTypes, [
  'ELEARNING_QUESTION',
  'QUESTION_TEXT',
  'QUESTION_MULTIPLE_CHOICE',
  'QUESTION_SLIDER',
  'QUESTION_DATE_TIME',
  'QUESTION_NUMBER',
  'QUESTION_DROPDOWN',
  'QUESTION_BOOLEAN',
  'QUESTION_FILE_UPLOAD',
  'QUESTION_CHECKLIST',
]);

export enum EAcademySortableTypes {
  SECTION = 'section',
  MODULE = 'module_item'
}

export enum EModuleStatus {
  ACTIVE = 'active',
  CONCEPT = 'concept',
}

export enum EModuleTypes {
  CONTENT = 'content',
  QUIZ = 'quiz',
}

export enum ECourseTypes {
  ONBOARDING = 'onboarding',
  ACADEMY = 'academy',
}
